/**
 * Save-this-image, as an icon.
 *
 * One component rather than three copies of the glyph: the button shows up in
 * the studio's result bar, the full-size preview and the gallery's detail panel,
 * and a download that looks different in each place reads as a different action.
 *
 * Icon-only, so the label lives in `title` + `aria-label` — it is still the
 * button's accessible name.
 */
const S = {
  fill: 'none', stroke: 'currentColor', strokeWidth: 2,
  strokeLinecap: 'round', strokeLinejoin: 'round',
} as const;

export interface DownloadButtonProps {
  onClick: () => void;
  /** Accessible name; also the tooltip. */
  title?: string;
  disabled?: boolean;
}

export default function DownloadButton({ onClick, title = 'Download', disabled }: DownloadButtonProps) {
  return (
    <button
      className="btn btn-sm btn-icon"
      title={title}
      aria-label={title}
      disabled={disabled}
      onClick={onClick}
    >
      {/* 18px, not 15: with .btn-icon's 5px padding that makes the button
          exactly as tall as the text buttons it sits beside. */}
      <svg viewBox="0 0 24 24" width={18} height={18} {...S}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <path d="m7 10 5 5 5-5" />
        <path d="M12 15V3" />
      </svg>
    </button>
  );
}
